import { content } from "../config/content.js";
import { createNav, bindNav } from "./components/Nav.js";
import { createHeroSection } from "./sections/Hero.js";
import { createManifestoSection } from "./sections/Manifesto.js";
import { createNumbersSection } from "./sections/Numbers.js";
import { createTestimonialsSection } from "./sections/Testimonials.js";
import { createAdvantageSection } from "./sections/Advantage.js";
import { createTeamSection } from "./sections/Team.js";
import { createServicesFaqsSection } from "./sections/services/ServicesFaqs.js";
import { createContactSection } from "./sections/Contact.js";
import { createFooter } from "./sections/Footer.js";

export function mountLandingPage(root) {
  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer";

  const nav = createNav();
  const contact = createContactSection();
  contact.classList.add("contact--on-white");

  contentLayer.append(
    nav,
    createHeroSection(),
    createManifestoSection(),
    createNumbersSection(),
    createTestimonialsSection(),
    createAdvantageSection(),
    createTeamSection(),
    createServicesFaqsSection(content.faqs, { serviceRail: true }),
    contact,
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, { page: "home" });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: "Taldel — Offshore Engineering Teams",
    sections: {
      hero: contentLayer.querySelector("#hero"),
      manifesto: contentLayer.querySelector("#manifesto"),
      numbers: contentLayer.querySelector("#numbers"),
      testimonials: contentLayer.querySelector("#testimonials"),
      advantage: contentLayer.querySelector("#advantage"),
      team: contentLayer.querySelector("#team"),
      faqs: contentLayer.querySelector("#faqs"),
      contact: contentLayer.querySelector("#contact"),
    },
  };
}
